import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "login",
  style: {"height":"100%","display":"flex","align-items":"center"}
}
const _hoisted_2 = { style: {"margin-right":"20px"} }

import { ElButton, ElPopover, ElIcon } from 'element-plus'
import { User } from '@element-plus/icons-vue'
import { onMounted } from 'vue'
import { initClient } from '@/common/inituser'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const handleClick = () => {
    ; (window as any).openGlobalLogin?.()
}
const userStore = useUserStore()
const islogin = userStore.isLoggedIn

const handleLogout = () => {
    // @ts-ignore
    Auth.request.requestor({
        url: "/open/jssdk/init/user/logout",
        method: "get",

    }).then(() => {
        userStore.clearAuth()
        window.location.href = '/editor'
    })
}
onMounted(() => {
    console.log(userStore.isLoggedIn, 'islogin')
    if (islogin) {
        // initClient()
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(islogin))
      ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          type: "primary",
          size: "large",
          onClick: handleClick
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("登录/注册", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(islogin))
      ? (_openBlock(), _createBlock(_unref(ElPopover), {
          key: 1,
          placement: "top-end",
          width: 150,
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElIcon), { size: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(User))
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", { class: "content" }, [
              _createElementVNode("div", {
                class: "item",
                onClick: handleLogout
              }, " 退出登录 ")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})